'use client';
import CardMedia from '@mui/material/CardMedia';
import { useDelayedState } from '@/hooks/useDelayedState';

const FALLBACK_IMAGE_URL = '/images/no-image.png';

type Props = {
  imageUrl?: string;
  imageAlt?: string;
  disappearWhenInvalidImage?: boolean;
};

export const EventImage: React.FC<Props> = ({
  imageUrl,
  imageAlt,
  disappearWhenInvalidImage
}) => {
  const [image, setImage] = useDelayedState<string | undefined>(
    undefined,
    imageUrl ?? FALLBACK_IMAGE_URL
  );

  const onError = () => {
    setImage(FALLBACK_IMAGE_URL);
  };
  if (disappearWhenInvalidImage && image === FALLBACK_IMAGE_URL) {
    return null;
  }
  return (
    <CardMedia
      component="img"
      sx={{
        width: '100%',
        objectFit: 'contain'
      }}
      image={image}
      alt={(image && imageAlt) || ''}
      onError={onError}
      loading="lazy"
    />
  );
};
